export { default as SearchSection } from './SearchSection';



// WEBPACK FOOTER //
// ./src/containers/SearchPage/SearchSection/index.ts